/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_BiddingInputs */

const cs_sreality_attr_bidding = /** @type {(inputs: Sreality_Attr_BiddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Způsob licitace`)
};

const en_sreality_attr_bidding = /** @type {(inputs: Sreality_Attr_BiddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidding Method`)
};

/**
* | output |
* | --- |
* | "Bidding Method" |
*
* @param {Sreality_Attr_BiddingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_bidding = /** @type {((inputs?: Sreality_Attr_BiddingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_BiddingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_bidding(inputs)
	return cs_sreality_attr_bidding(inputs)
});